import { isPresent } from '@shared/utils/helpers';
import distance from 'turf-distance';

export interface LatLng {
    lat: number;
    lng: number;
}

export function distanceBetween(from: LatLng, to: LatLng, unit = 'metres') {
    const convertToMetres = ['metres', 'meters'].indexOf(unit) > -1;

    const calculatedDistance = distance(
        {
            type: 'Feature',
            properties: {},
            geometry: {
                type: 'Point',
                coordinates: [from.lng, from.lat],
            },
        },
        {
            type: 'Feature',
            properties: {},
            geometry: {
                type: 'Point',
                coordinates: [to.lng, to.lat],
            },
        },
        convertToMetres ? 'kilometres' : unit,
    );

    return convertToMetres ? Math.round(calculatedDistance * 1000) : calculatedDistance;
}

export function readableFromMeters(meters: number): string {
    if (!isPresent(meters)) {
        return undefined;
    }

    if (meters < 1000) {
        return `${meters}m`;
    }

    return `${meters / 1000}km`;
}
